import React from 'react';
import { Clock, ChevronRight } from 'lucide-react';

function fmtDate(d) {
  if (!d) return '—';
  const dt = new Date(d);
  const today = new Date();
  if (dt.toDateString() === today.toDateString()) return 'Today';
  const yesterday = new Date(today); yesterday.setDate(today.getDate() - 1);
  if (dt.toDateString() === yesterday.toDateString()) return 'Yesterday';
  return dt.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
}

function isOverdue(d) {
  if (!d) return false;
  return new Date(d) < new Date(new Date().toDateString());
}

function initials(first, last) {
  return `${(first || '')[0] || ''}${(last || '')[0] || ''}`.toUpperCase() || '?';
}

export default function FollowupsSection({ rows, count, isTeam, onSeeAll, onRowClick }) {
  const visible = (rows || []).slice(0, 5);

  if (!visible.length) {
    return (
      <div className="my-day-card">
        <SectionHeader count={count} onSeeAll={onSeeAll} />
        <p style={{ fontSize: 12, color: '#6C757D', margin: '12px 0 0', textAlign: 'center' }}>All follow-ups are up to date.</p>
      </div>
    );
  }

  return (
    <div className="my-day-card">
      <SectionHeader count={count} onSeeAll={onSeeAll} />
      <div className="responsive-scroll">
        <table style={{ width: '100%', minWidth: 300, borderCollapse: 'collapse', fontSize: 12, marginTop: 8 }}>
          <thead>
            <tr>
              <th style={{ ...th, textAlign: 'left' }}>Contact</th>
              <th style={th}>Due</th>
              <th style={th}>Stage</th>
              {isTeam && <th style={th}>Owner</th>}
            </tr>
          </thead>
          <tbody>
            {visible.map(c => {
              const overdue = isOverdue(c.next_follow_up_date);
              return (
                <tr
                  key={c.id}
                  className={onRowClick ? 'my-day-row-clickable' : ''}
                  onClick={onRowClick ? () => onRowClick(c) : undefined}
                  tabIndex={onRowClick ? 0 : undefined}
                  onKeyDown={onRowClick ? (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onRowClick(c); } } : undefined}
                  style={{ borderTop: '1px solid #F0F0F0' }}
                >
                  <td style={td}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 7 }}>
                      <div style={{ width: 26, height: 26, borderRadius: '50%', background: '#E8F4F8', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 10, fontWeight: 700, color: '#2E8B98', flexShrink: 0 }}>
                        {initials(c.first_name, c.last_name)}
                      </div>
                      <span style={{ fontWeight: 500, color: '#212529' }}>{c.first_name} {c.last_name}</span>
                    </div>
                  </td>
                  <td style={{ ...td, textAlign: 'center', color: overdue ? '#DC3545' : '#495057', fontWeight: overdue ? 700 : 400 }}>
                    {fmtDate(c.next_follow_up_date)}
                  </td>
                  <td style={{ ...td, textAlign: 'center' }}>
                    <span style={{ background: '#F8F9FA', color: '#6C757D', padding: '2px 7px', borderRadius: 8, fontSize: 11, textTransform: 'capitalize' }}>
                      {(c.pipeline_stage || 'new').replace(/_/g, ' ')}
                    </span>
                  </td>
                  {isTeam && <td style={{ ...td, textAlign: 'center', color: '#6C757D' }}>{c.assignee_name || '—'}</td>}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      {onSeeAll && <SeeAllLink onSeeAll={onSeeAll} />}
    </div>
  );
}

function SectionHeader({ count, onSeeAll }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 4 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
        <Clock size={15} color="#2E8B98" />
        <span style={{ fontSize: 13, fontWeight: 700, color: '#212529' }}>Follow-ups due</span>
        {count > 0 && <span className="my-day-count-badge active">{count}</span>}
        {count === 0 && <span className="my-day-count-badge">0</span>}
      </div>
    </div>
  );
}

function SeeAllLink({ onSeeAll }) {
  return (
    <button onClick={onSeeAll} style={{ display: 'flex', alignItems: 'center', gap: 3, marginTop: 10, background: 'none', border: 'none', color: '#2E8B98', fontSize: 12, fontWeight: 600, cursor: 'pointer', padding: 0 }}>
      See all <ChevronRight size={13} />
    </button>
  );
}

const th = { padding: '4px 8px', fontWeight: 600, fontSize: 11, color: '#ADB5BD', textAlign: 'center' };
const td = { padding: '7px 8px', color: '#495057' };
